import { auth } from '~/api/auth';
import { isAgent, isNogoManager, isSales } from './getDecodedJwt';

export const getShouldGoToDashboard = () => {
  const currentApplication = auth.getAgentApplicationId();
  // nogo-manager reuses the agent dashboard shell (same as agent/team-lead) to list
  // the applications assigned to them for pricing approval.
  const shouldGoToDashboard: boolean = (isAgent() || isNogoManager()) && !currentApplication;
  return shouldGoToDashboard;
};

export const getPortalType = () => {
  const portalType: string = isSales() ? 'sales' : isAgent() ? 'agent' : 'merchant';
  return portalType;
};
